import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-14_cxa6ui.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-9_sbdveb.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-9_sbdveb.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 md:mb-6 mt-2 text-[#152C24]">DEVELOPEMNT PARTNER</h1>
    
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281936/image-3_fikesp.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        {/* Benefits Section Header */}
        <div className="flex-1">
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
              <strong className="font-bold text-black">DEVELOPMENT PARTNER: </strong>
              What are the benefits?
            </h2>

            <h2 className="font-bold text-[32px] text-black mb-6">
            Development partner (like NGOs, donors, government agencies, or impact investors) benefits from using the Farmnet App:
            </h2>

            <div className="md:space-y-10 text-[32px] mt-10">
              <div>
                <strong>1. Access to Verified Farmer & Agribusiness Data</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Gain access to real-time data on farmer profiles, locations, farm sizes, crops grown, and farming practices.</li>
                  <li>Helps with targeting, planning, and monitoring agricultural development programs.</li>
                </ul>
              </div>

              <div>
                <strong>2. Easy Implementation of Projects</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Use Farmnet as a delivery platform for interventions (e.g., subsidized inputs, training, financial inclusion).</li>
                  <li>Mobilize and engage farmer groups or cooperatives directly through the app.</li>
                </ul>
              </div>

              <div>
                <strong>3. Improved Monitoring & Evaluation (M&E)</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Track project outcomes with real-time dashboards: yields, incomes, service usage, gender data, etc.</li>
                  <li>Automates reporting and KPIs for donors and stakeholders.</li>
                </ul>
              </div>

              <div>
                <strong>4. Promote Financial Inclusion</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Link farmers to credit, insurance, and mobile banking services via Farmnet’s digital ecosystem.</li>
                  <li>Monitor loan uptake, repayment, and financial behavior.</li>
                </ul>
              </div>

              <div>
                <strong>5. Support for Climate-Smart & Sustainable Ag</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Promote climate-resilient practices, like agroforestry, soil health, and input efficiency.</li>
                  <li>Monitor adoption rates and environmental impacts via farm data.</li>
                </ul>
              </div>

              <div>
                <strong>6. Digital Extension Services</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Push tailored training content, weather alerts, and advisory messages to thousands of farmers at once.</li>
                  <li>Reduce costs of field visits and extension agent deployment.</li>
                </ul>
              </div>

              <div>
                <strong>7. Gender & Youth Inclusion</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Disaggregate data by gender, age, and location to target women and youth more effectively.</li>
                  <li>Promote inclusive services like training, access to inputs, or entrepreneurship programs.</li>
                </ul>
              </div>

              <div>
                <strong>8. Transparent Impact & Reporting</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Build confidence with donors by showing real-time impact metrics (e.g. yield increases, income growth, resilience indicators).</li>
                  <li>Supports traceable, auditable, and scalable impact delivery.</li>
                </ul>
              </div>

              <div>
                <strong>9. Collaboration with Ecosystem Players</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Coordinate with offtakers, service providers, and government on a shared platform.</li>
                  <li>Strengthens value chain linkages and avoids duplication of efforts.</li>
                </ul>
              </div>

              <div>
                <strong>10. Scalable, Replicable Model</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Deploy successful interventions in new regions easily using Farmnet’s infrastructure.</li>
                  <li>Saves time and cost by avoiding building new systems from scratch.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Solutions2;
